import React from 'react';
import {classes, style, vars} from './doppe-viewer-cover-view.st.css';
import {useBymoPageProps} from '../../client-server-common';
import {doppeHideableValueGetValue} from '../../client-server-common/types/doppe-hideable-value';
import {HtmlObjectHorizontalPosition, HtmlObjectResizeMode, HtmlObjectVerticalPosition} from '@wix/devzai-utils-common';
import {
    DoppePageDefaultImageView,
    DoppePageDefaultImageViewImage
} from "../doppe-page-default-image-view/doppe-page-default-image-view";
import {DoppePageMediaView} from "../doppe-page-media-view/doppe-page-media-view";
import {BymoPageLayout} from "../bymo-page-style/bymo-page-style";

export const DoppeViewerCoverView = React.memo(function DoppeViewerCoverView(props: DoppeViewerCoverView.Props) {
    const {
        desktopHeight = 250,
        mobileHeight = 200,
        fluidOnDesktop = false,

        style: styleProp,
        className,
        ...htmlAttributes
    } = props;

    const bymoPageProps = useBymoPageProps();

    const coverPhoto = doppeHideableValueGetValue(bymoPageProps.coverPhoto);

    return (
        <div
            {...htmlAttributes}
            style={{
                [vars.desktopHeight]: `${desktopHeight}px`,
                [vars.mobileHeight]: `${mobileHeight}px`,
                ...styleProp
            }}
            className={style(classes.root, className)}
        >
            <DoppePageMediaView
                className={style(classes.mediaView, className)}
                mediaResource={coverPhoto}
                layoutSpec={
                    layout => layout === BymoPageLayout.Wide ?
                        {height: desktopHeight} :
                        {height: mobileHeight}
                }
                widthSpec={
                    layout => fluidOnDesktop && layout === BymoPageLayout.Wide ?
                        {screenRelativeWidth: 1} :
                        {contentRelativeWidth: 1}
                }
                mediaResizeMode={HtmlObjectResizeMode.Cover}
                mediaVerticalPosition={HtmlObjectVerticalPosition.Center}
                mediaHorizontalPosition={HtmlObjectHorizontalPosition.Center}
                videoMuted={true}
                autoPlayVideo={true}
                playVideoInLoop={true}
                emptyMediaPlaceholder={(
                    <DoppePageDefaultImageView
                        image={DoppePageDefaultImageViewImage.CoverImage}
                    />
                )}
            />
        </div>
    )
});

export namespace DoppeViewerCoverView {

    export interface Props extends React.HTMLAttributes<any> {
        desktopHeight?: number;
        mobileHeight?: number;
        fluidOnDesktop?: boolean;
    }
}